export default {"src":"/_next/static/media/npxs.95eafd7c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};